<template>
  <div class="input-group" v-bind:style="{ width: inputWidth + 'px' }">
			<span class="input-group-btn" v-if="controls"> 
            <button type="button" class="btn btn-primary" @click="decrease" :disabled="minDisabled">-</button> 
      </span>
      <input type="text" class="form-control text-center" :value="value" :disabled="disabled" :max="max" :min="min" ref="input" @blur="handleBlur(value)" v-on:input="setTempValue($event.target.value)"> 
      <span class="input-group-btn" v-if="controls"> 
            <button type="button" class="btn btn-primary" @click="increase" :disabled="maxDisabled">+</button> 
      </span>
	</div>
</template>
<script>

  export default {
    name: 'InputNumber',
    props: {
      step: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
        default: Infinity
      },
      min: {
        type: Number,
        default: -Infinity
      },
      value: {
        default: 0
      },
      disabled: Boolean,
      controls: {
        type: Boolean,
        default: true
      },
      inputWidth:{
      	type: Number,
        default: 150
      }
    },
    data() {
      return {
        currentValue: 0,
        defaultValue:this.value
      };
    },
    computed: {
      minDisabled() {
        return this._decrease(this.value, this.step) < this.min;
      },
      maxDisabled() {
        return this._increase(this.value, this.step) > this.max;
      },
      precision() {
        const { value, step, getPrecision } = this;
        return Math.max(getPrecision(value), getPrecision(step));
      }
    },
    methods: {
      toPrecision(num, precision) {
        if (precision === undefined) precision = this.precision;
        return parseFloat(parseFloat(Number(num).toFixed(precision)));
      },
      getPrecision(value) {
        const valueString = value.toString();
        const dotPosition = valueString.indexOf('.');
        let precision = 0;
        if (dotPosition !== -1) {
          precision = valueString.length - dotPosition - 1;
        }
        return precision;
      },
      _increase(val, step) {
        if (typeof val !== 'number') return this.currentValue;

        const precisionFactor = Math.pow(10, this.precision);

        return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
      },
      _decrease(val, step) {
        if (typeof val !== 'number') return this.currentValue;

        const precisionFactor = Math.pow(10, this.precision);

        return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
      },
      increase() {
        if (this.disabled || this.maxDisabled) return;
        const value = this.value || 0;
        const newVal = this._increase(value, this.step);
        if (newVal > this.max) {
        	this.$emit('input', this.max);
        }else{
        	this.$emit('input', newVal);
        }
      },
      decrease() {
        if (this.disabled || this.minDisabled) return;
        const value = this.value || 0;
        const newVal = this._decrease(value, this.step);
        if (newVal < this.min) {
        	this.$emit('input', this.min);
        }else{
        	this.$emit('input', newVal);
        }
      },
      handleBlur(newVal) {
        if(newVal < this.min)	{
      	  this.$refs.input.value = this.min;
      	   this.$emit('input', this.min)
        }
        if (this.$refs.input.value===''){
        	this.$refs.input.value = this.defaultValue;
      		this.$emit('input', this.defaultValue);
      	}
      },
      setTempValue(value){
      	if (value===''){
      		return
      	}
      	var newVal = Number(value);
      	if (isNaN(newVal)) {
        	newVal=this.defaultValue;
        }
      	if (newVal >= this.max) {
        	newVal = this.max;
        }
        if (newVal <= this.min && this.min <=1) {
        	  newVal = this.min;
        }
	      if (newVal !== value) {
	        this.$refs.input.value = newVal
	      }
	      this.$emit('input', newVal)
      }
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// InputNumber.vue?4a24bf81